module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-policy-button"
  }, [_c('div', {
    staticClass: "dropdown-buttons"
  }, [_c('PageReveal', {
    attrs: {
      "item": _vm.item
    }
  }), _c('ActionButton', {
    attrs: {
      "action": _vm.remove,
      "confirm": "confirm"
    }
  }, [_vm._v("Delete")]), _c('a', {
    staticClass: "button",
    attrs: {
      "href": _vm.appUrl,
      "target": "_blank"
    }
  }, [_vm._v("Preview")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5cc64474!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/structure/ui/actions/PageButtons.vue
// module id = 2525
// module chunks = 1